module.exports = __webpack_public_path__ + "assets/img/18_935_big.020f52ba.jpg";